// extracted by mini-css-extract-plugin
export var container = "_74-0";
export var icon = "_74-1";
export var text = "_74-2";